import { Bell, Key } from 'react-feather';
// ** Reactstrap Imports
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';

const NotificationBell = ({ countLeave, countFlexTime, countTimeRecord, countMfgM75, showMfgM75, total }) => {
  // if (!countLeave || !countFlexTime || !countTimeRecord) {
  //   return null;
  // }

  return (
    <UncontrolledDropdown tag='li' className='dropdown-user nav-item' size='sm'>
      <DropdownToggle href='/' tag='a' className='nav-link dropdown-user-link' onClick={(e) => e.preventDefault()}>
        <div className='relative inline-block '>
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <Bell size={24} className='ficon' style={{ marginRight: 15, cursor: 'pointer' }} />
            {total > 0 ? (
              <span
                style={{
                  position: 'absolute',
                  top: '-9px',
                  right: '3px',
                  background: 'red',
                  color: 'white',
                  width: total > 9 ? '24px' : '20px', // ปรับขนาดตามจำนวนตัวเลข
                  height: '20px',
                  borderRadius: '50%',
                  textAlign: 'center',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  padding: '2px'
                }}
              >
                {total == 0 ? null : total}
              </span>
            ) : null}
          </div>
        </div>
      </DropdownToggle>
      <DropdownMenu className='mt-0' container='body' end>
        <DropdownItem
          className='d-flex align-items-center'
          tag='a'
          onClick={() => window.location.replace(process.env.REACT_APP_APPROVAL_PAGE_URL)}
        >
          <Key size={14} className='me-75' />
          <span className='align-middle'>การอนุมัติการลา</span>
          {countLeave > 0 && (
            <span
              style={{
                background: 'red',
                color: 'white',
                width: countLeave > 9 ? '18px' : '18px', // ปรับขนาดตามจำนวนตัวเลข
                height: '18px',
                borderRadius: '50%',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                fontWeight: 'bold',
                padding: '2px',
                marginLeft: '0.7em',
                justifySelf: 'flex-end'
              }}
            >
              {countLeave}
            </span>
          )}
        </DropdownItem>
        <DropdownItem
          className='d-flex align-items-center'
          tag='a'
          onClick={() => window.location.replace(process.env.REACT_APP_FLEX_TIME_APPROVAL_PAGE_URL)}
        >
          <Key size={14} className='me-75' />
          <span className='align-middle'>การอนุมัติ Flex Time</span>
          {countFlexTime > 0 && (
            <span
              style={{
                background: 'red',
                color: 'white',
                width: countFlexTime > 9 ? '18px' : '18px', // ปรับขนาดตามจำนวนตัวเลข
                height: '18px',
                borderRadius: '50%',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                fontWeight: 'bold',
                padding: '2px',
                marginLeft: '0.7em',
                justifySelf: 'flex-end'
              }}
            >
              {countFlexTime > 99 ? '99+' : countFlexTime}
            </span>
          )}
        </DropdownItem>
        <DropdownItem
          className='d-flex align-items-center'
          //  href='/'
          tag='a'
          onClick={() => window.location.replace(process.env.REACT_APP_TIME_RECORD_APPROVAL_PAGE_URL)}
        >
          <Key size={14} className='me-75' />
          <span className='align-middle'>การอนุมัติขอเวลาทำงาน</span>
          {countTimeRecord > 0 && (
            <span
              style={{
                background: 'red',
                color: 'white',
                width: countTimeRecord > 9 ? '18px' : '18px', // ปรับขนาดตามจำนวนตัวเลข
                height: '18px',
                borderRadius: '50%',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                fontWeight: 'bold',
                padding: '2px',
                marginLeft: '0.7em',
                justifySelf: 'flex-start'
              }}
            >
              {countTimeRecord > 99 ? '99+' : countTimeRecord}
            </span>
          )}
        </DropdownItem>
        {showMfgM75 && (
          <DropdownItem
            className='d-flex align-items-center'
            tag='a'
            onClick={() => window.location.replace('/mfg-m75-approval')}
          >
            <Key size={14} className='me-75' />
            <span className='align-middle'>การอนุมัติการขอ ม.75</span>
            {countMfgM75 > 0 && (
              <span
                style={{
                  background: 'red',
                  color: 'white',
                  width: '18px',
                  height: '18px',
                  borderRadius: '50%',
                  textAlign: 'center',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  padding: '2px',
                  marginLeft: '0.7em'
                }}
              >
                {countMfgM75 > 99 ? '99+' : countMfgM75}
              </span>
            )}
          </DropdownItem>
        )}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default NotificationBell;
